// node_modules
import { FC, useState } from "react";
// Components
import { FindestTextBox, ProseMirrorEditor } from "Components";
// Controllers
import { MediaControllerSingleton, ProseMirrorPluginControllerSingleton } from "Controllers";
// Types
import { TTechnologyYoutubeVideoDTO } from "Types";
// Styles
import styles from "styles/addMediaModal.module.scss";
// Helpers
import { ToastHelperSingleton } from "Helpers";
// Enums
import { ToastTypeEnum } from "Enums";
import { RegexConstants } from "Constants";

type TAddYoutubeVideoModal = {
    technologyId?: number,
    addYoutubeVideo?: (video: TTechnologyYoutubeVideoDTO) => void
}

export const AddYoutubeVideoModal: FC<TAddYoutubeVideoModal> = ({ technologyId, addYoutubeVideo }: TAddYoutubeVideoModal) => {

    const [youtubeUrl, setYoutubeUrl] = useState<string>("");
    const [imageUrl, setImageUrl] = useState<undefined | string>(undefined);
    const [caption, setCaption] = useState<string>("");

    function getYoutubeId(link: string) {
        const matches = link.match(RegexConstants.VALID_YOUTUBE_URL);
        if (matches !== null) return matches[1];
        return "";
    }

    const changeYoutubeUrl = (url: string) => {
        const youtubeID = getYoutubeId(url);
        setImageUrl(`https://img.youtube.com/vi/${youtubeID}/default.jpg`);
        setYoutubeUrl(url);
    };

    const captionChanged = (text: string) => {
        setCaption(text);
    };

    const onAddYoutubeVideoClick = async () => {
        if(youtubeUrl.trim().length === 0) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Please insert a valid url for a youtube video.");
            return;
        }

        const newlyAddedYoutubeVideo = await MediaControllerSingleton.AddYoutubeVideoToTechnology(technologyId!, youtubeUrl, caption);
        if(addYoutubeVideo) addYoutubeVideo(newlyAddedYoutubeVideo);
    };

    return (
        <div className={styles.addMediaModalContainer}>
            <div className={styles.addMedia}>
                <span>Youtube video url:</span>
                <FindestTextBox onChange={changeYoutubeUrl} />
            </div>
            <div className={styles.aspectRatioBox}>
                <div className={styles.aspectRatioBoxContent}>
                    {imageUrl ? 
                        <img src={imageUrl} alt="Preview of youtube video"/>
                        :
                        <div>Empty preview of youtube video</div>
                    }
                </div>
            </div>
            <div className={styles.captionContainer}>
                <span>Caption text</span>
                <ProseMirrorEditor source="" plugins={ProseMirrorPluginControllerSingleton.getDefault()} 
                    documentChanged={captionChanged} extraClassNameWisiwygContent={styles.captionText}/>
            </div>
            <button className={[styles.coloredButton, styles.purple].join(" ")} onClick={onAddYoutubeVideoClick}>Add video</button>
        </div>
    );
}